const CACHE_KEY = 'currentUserProfile';

export const currentProfileCache = {
  get() {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch (error) {
      console.warn('[currentProfileCache] Failed to get cached profile:', error);
      return null;
    }
  },
  set(profileData) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(profileData));
    } catch (error) {
      console.warn('[currentProfileCache] Failed to cache profile:', error);
    }
  },
  clear() {
    try {
      sessionStorage.removeItem(CACHE_KEY);
    } catch (error) {
      console.warn('[currentProfileCache] Failed to clear cached profile:', error);
    }
  },
  has() {
    return sessionStorage.getItem(CACHE_KEY) !== null;
  }
}; 